module.exports = __webpack_public_path__ + "static/media/cover_eng_9_10.83ab9bac.jpg";